"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDropZoneColumn = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var react_grid_system_1 = require("react-grid-system");
var model_1 = require("../../../model");
var WidgetDropZone_1 = require("./WidgetDropZone");
var useDashboardDrop_1 = require("../useDashboardDrop");
var useInsightListItemDropHandler_1 = require("./useInsightListItemDropHandler");
var useInsightPlaceholderDropHandler_1 = require("./useInsightPlaceholderDropHandler");
var useKpiPlaceholderDropHandler_1 = require("./useKpiPlaceholderDropHandler");
var useMoveWidgetHandler_1 = require("./useMoveWidgetHandler");
var sizing_1 = require("../../../_staging/layout/sizing");
var types_1 = require("../types");
exports.WidgetDropZoneColumn = function (props) {
    var sectionIndex = props.sectionIndex, itemIndex = props.itemIndex, _a = props.isLastInSection, isLastInSection = _a === void 0 ? false : _a;
    var dropzoneCoordinates = model_1.useDashboardSelector(model_1.selectDraggingWidgetTarget);
    var handleInsightListItemDrop = useInsightListItemDropHandler_1.useInsightListItemDropHandler(sectionIndex, itemIndex);
    var handleInsightPlaceholderDrop = useInsightPlaceholderDropHandler_1.useInsightPlaceholderDropHandler(sectionIndex, itemIndex);
    var handleKpiPlaceholderDrop = useKpiPlaceholderDropHandler_1.useKpiPlaceholderDropHandler(sectionIndex, itemIndex);
    var handleWidgetDrop = useMoveWidgetHandler_1.useMoveWidgetDropHandler(sectionIndex, itemIndex);
    var dispatch = model_1.useDashboardDispatch();
    var _b = tslib_1.__read(useDashboardDrop_1.useDashboardDrop(["insightListItem", "kpi-placeholder", "insight-placeholder", "kpi", "insight"], {
        drop: function (item) {
            if (types_1.isInsightDraggableListItem(item)) {
                handleInsightListItemDrop(item.insight);
            }
            if (types_1.isKpiPlaceholderDraggableItem(item)) {
                handleKpiPlaceholderDrop();
            }
            if (types_1.isInsightPlaceholderDraggableItem(item)) {
                handleInsightPlaceholderDrop();
            }
            if (types_1.isInsightDraggableItem(item) || types_1.isKpiDraggableItem(item)) {
                handleWidgetDrop(item);
            }
        },
    }, [dispatch, handleInsightListItemDrop, handleInsightPlaceholderDrop, handleKpiPlaceholderDrop]), 2), collectedProps = _b[0], dropRef = _b[1];
    var showDropZone = react_1.useMemo(function () {
        return (dropzoneCoordinates === null || dropzoneCoordinates === void 0 ? void 0 : dropzoneCoordinates.sectionIndex) === sectionIndex &&
            (dropzoneCoordinates === null || dropzoneCoordinates === void 0 ? void 0 : dropzoneCoordinates.itemIndex) === itemIndex;
    }, [dropzoneCoordinates === null || dropzoneCoordinates === void 0 ? void 0 : dropzoneCoordinates.itemIndex, dropzoneCoordinates === null || dropzoneCoordinates === void 0 ? void 0 : dropzoneCoordinates.sectionIndex, itemIndex, sectionIndex]);
    if (!showDropZone) {
        return null;
    }
    var size = collectedProps.item.size;
    return (react_1.default.createElement(react_grid_system_1.Col, { xl: size.gridWidth, lg: size.gridWidth, md: size.gridWidth, sm: size.gridWidth, xs: size.gridWidth, className: classnames_1.default("gd-fluidlayout-column", "gd-fluidlayout-column-dropzone", "s-fluid-layout-column"), style: {
            minHeight: sizing_1.getDashboardLayoutItemHeightForGrid(size.gridHeight),
        } },
        react_1.default.createElement(WidgetDropZone_1.WidgetDropZone, { isLastInSection: isLastInSection, sectionIndex: sectionIndex, itemIndex: itemIndex, dropRef: dropRef })));
};
//# sourceMappingURL=WidgetDropZoneColumn.js.map